module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_13.efb59622.mp3";